export default {
  login: {
    path: '/',
    name: 'public.login'
  },
  private: {
    path: '',
    name: 'private'
  },
  sellers: {
    path: '/Sellers',
    name: 'private.sellers'
  },
  sellersList: {
    path: '/Sellers/List',
    name: 'private.sellers.list'
  },
  sellersDelegations: {
    path: '/Sellers/Delegations',
    name: 'private.sellers.delegations'
  },
  sellersTypes: {
    path: '/Sellers/Types',
    name: 'private.sellers.types'
  },
  clientsRecords: {
    path: '/ClientsRecords',
    name: 'private.clients_records'
  },
  clientsRecordsList: {
    path: '/ClientsRecords/List',
    name: 'private.clients_records.list'
  },
  clients: {
    path: '/Clients',
    name: 'private.clients'
  },
  clientsList: {
    path: '/Clients/List',
    name: 'private.clients.list'
  },
  contracts: {
    path: '/Contracts',
    name: 'private.contracts'
  },
  contractsList: {
    path: '/Contracts/List',
    name: 'private.contracts.list'
  },
  contractsSDA: {
    path: '/Contracts/SDA',
    name: 'private.contracts.sda'
  },
  contractsZips: {
    path: '/Contracts/zips',
    name: 'private.contracts.zips'
  },
  reports: {
    path: '/Reports',
    name: 'private.reports'
  },
  reportsMasterData: {
    path: '/Reports/MasterData',
    name: 'private.reports.master_data'
  },
  reportsSDA: {
    path: '/Reports/SDA',
    name: 'private.reports.sda'
  },
  reportsPotential: {
    path: '/Reports/Potential',
    name: 'private.reports.potential'
  },
  reportsCCI: {
    path: '/Reports/CCI',
    name: 'private.reports.cci'
  },
  reportsEducation: {
    path: '/Reports/Education',
    name: 'private.reports.education'
  },
  history: {
    path: '/history',
    name: 'private.history'
  },
  historyContracts: {
    path: '/history/contracts',
    name: 'private.history.contracts'
  },
  historyContractsSDA: {
    path: '/history/SDA',
    name: 'private.history.sda'
  }
}



// WEBPACK FOOTER //
// ./src/router/routes.js